import type { DesignCode } from "../types/input";
import type { CodeProfile } from "./types";
import { TBDY_PROFILE } from "./tbdy";
import { EC_PROFILE } from "./ec";
import { US_PROFILE } from "./us";

export type { CodeProfile } from "./types";
export { ecCombinations, ecSeismicCombination, type EcCombination, type PartialFactors } from "./ec";

export const CODE_PROFILES: Record<DesignCode, CodeProfile> = { tbdy2018: TBDY_PROFILE, ec7: EC_PROFILE, us: US_PROFILE };
export const getProfile = (code: DesignCode | undefined): CodeProfile => CODE_PROFILES[code ?? "tbdy2018"];
